import $ from 'jquery'
import Swiper from 'swiper'

export default {
  init() {
    $( ".bottleSlider-slider" ).each(function( index ) {
      const s = new Swiper($(this)[0], {
        slidesPerView: IS_MOBILE ? 'auto' : 2,
        spaceBetween: IS_MOBILE ? 30 : 40,
        loop: IS_MOBILE ? true : false,
        on: {
          slideChange: function() {
            const barWidth = $(this.$el).find('.bottleSlider-scrollBar').width()
            const nbSlides = $(this.$el).find('.swiper-slide:not(.swiper-slide-duplicate)').length
            $(this.$el).find('.bottleSlider-currentSlide').text(this.realIndex + 1 < 10 ? `0${this.realIndex + 1}` : this.realIndex + 1)
            $(this.$el).find('.bottleSlider-scrollBar-bar').css('margin-left', this.realIndex * (barWidth / nbSlides) + 'px')
          },
          init: function() {
            const barWidth = $(this.$el).find('.bottleSlider-scrollBar').width()
            const nbSlides = $(this.$el).find('.swiper-slide:not(.swiper-slide-duplicate)').length
            $(this.$el).find('.bottleSlider-scrollBar-bar').css('width', barWidth / nbSlides + 'px')
          }
        },
      })

      $(this).find('.bottleSlider-nav-item--next').on('click', () => {
        s.slideNext()
      })

      $(this).find('.bottleSlider-nav-item--prev').on('click', () => {
        s.slidePrev()
      })
    })
  }
};
